<template>
	<v-layout
		row
		wrap
		ma-0
		justify-center
		align-center
	>
		<v-flex
			xs12
			:sm9="isCentered"
			:xl6="isCentered"
			:class="{ 'text-xs-center': isCentered, 'px-0': !isCentered }"
		>
			<transition
				name="scale-transition"
				mode="out-in"
			>
				<v-btn
					v-if="show === false"
					color="primary"
					ripple
					:class="{ 'ma-0': !isCentered }"
					@click="show = !show"
				>
					{{ buttonTitle }}
				</v-btn>
				<v-card v-if="show === true">
					<v-progress-linear
						:active="loading"
						:indeterminate="true"
					/>
					<v-container grid-list-xl>
						<slot name="form"/>
					</v-container>
				</v-card>
			</transition>
		</v-flex>
	</v-layout>
</template>

<script>

export default {
	props: {
		loading: { type: Boolean, default: false },
		alignButton: { type: String, default: 'center' },
		buttonTitle: { type: String, default: null },
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		isCentered() {
			return (this.alignButton === 'center');
		},
	},
	methods: {
		close() {
			this.show = false;
		},
	},
};
</script>

<style>

</style>
